// extracted by mini-css-extract-plugin
export default {"filtroAncho":"divisiones_filtroAncho__gAptu"};